import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

function About() {
  return (
    <Container maxWidth="md" sx={{ mt: 5, mb: 8 }}>
      <Typography variant="h3" component="h1" gutterBottom align="center" sx={{ fontWeight: 600 }}>
        About Check4DNR
      </Typography>
      
      <Paper elevation={2} sx={{ p: 4, borderRadius: 2, mt: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500 }}>
          Our Mission
        </Typography>
        <Typography variant="body1" paragraph>
          Check4DNR was founded with a clear mission: to ensure that everyone's medical wishes are respected, 
          especially in emergency situations. We bridge the gap between individuals with advance directives 
          and the emergency medical personnel who need immediate access to this critical information.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mt: 4 }}>
          The Problem We Solve
        </Typography>
        <Typography variant="body1" paragraph>
          Too often, advance directives like POLST forms and DNR orders are inaccessible when they're needed most. 
          They might be stored in a drawer at home, with a lawyer, or in a medical file that emergency responders 
          can't access. This leads to unwanted medical interventions or delays in care while family members 
          search for documentation.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mt: 4 }}>
          Our Solution
        </Typography>
        <Typography variant="body1" paragraph>
          Check4DNR utilizes secure facial recognition technology to provide instant access to your advance directives. 
          When emergency medical services need to know your wishes, they can simply take a photo with our app, 
          and if you're registered, they'll immediately have access to your documents.
        </Typography>
        
        <Typography variant="h5" gutterBottom sx={{ fontWeight: 500, mt: 4 }}>
          Our Team
        </Typography>
        <Typography variant="body1" paragraph>
          Our team consists of healthcare professionals, technology experts, and advocates for patient rights. 
          We're committed to maintaining the highest standards of security, privacy, and reliability in our service.
        </Typography>
      </Paper>
    </Container>
  );
}

export default About;